import React, { useState } from 'react';
import './VideoBanner.css';
import SubscriptionForm from './SubscriptionForm';

const VideoBanner = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="video-banner">
      {/* Banner Video */}
      <div className="video-container">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/kTxx_Jpnpn0?autoplay=1&mute=1&loop=1&playlist=kTxx_Jpnpn0"
          title="YouTube Banner Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Logo */}
      <div className="logo-container">
        <img 
          src="/images/logo.jpg" 
          alt="Logo" 
          className="logo" 
        />
      </div>

      {/* Two Column Videos */}
      <div className="video-grid">
        <div className="video-column">
          <div className="video-container">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/Z1LctxzEREE"
              title="YouTube Video 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="video-text">Stocks</div>
        </div>
        <div className="video-column">
          <div className="video-container">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/TKQmrAu33Sk"
              title="YouTube Video 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="video-text" style={{textAlign: 'center', fontWeight: 'bold'}}>Saints</div>
        </div>
      </div>

      {/* Subscribe Button */}
      <div className="subscribe-container">
        <button 
          className="subscribe-button"
          onClick={() => setShowForm(true)}
        >
          Subscribe Now
        </button>
      </div>

      {showForm && <SubscriptionForm onClose={() => setShowForm(false)} />}
    </div>
  );
};

export default VideoBanner;
